import './index.scss';

const Projects = () => (
  <section id="projects">
    <div className="sec-head reveal">
      <span className="sec-label">03</span>
      <h2 className="sec-title">Projects</h2>
    </div>

    <div className="proj-grid reveal">

      {/* LaLiga — featured full width */}
      <div className="proj-card span2">
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div className="proj-top">
            <span className="proj-num">01 · Featured</span>
            <div className="proj-links-top">
              {/* <a href="https://laliga-insights.vercel.app/" className="proj-link" target="_blank" rel="noopener noreferrer">
                Live Demo ↗
              </a> */}
            </div>
          </div>
          <div className="proj-title">LaLiga Insights</div>
          <div className="proj-highlight">
            <span className="highlight-pill green">30+ users · Week 1</span>
            <span className="highlight-pill">Organic growth</span>
          </div>
          <div className="proj-desc">
            Built and deployed a full-stack football analytics platform for filtering and
            comparing LaLiga players across teams, countries, positions, and performance
            metrics. Built the backend with <strong>Spring Boot</strong> and{' '}
            <strong>PostgreSQL</strong>, connected it to a React frontend, and attracted{' '}
            <strong>30+ users in the first week</strong> through fantasy football
            communities and LinkedIn.
          </div>
          <div className="proj-stack">
            <span>React</span><span>Spring Boot</span><span>PostgreSQL</span>
            <span>Supabase</span><span>Vercel</span><span>Heroku</span>
          </div>
        </div>

        <a
          href="https://laliga-insights.vercel.app/"
          target="_blank"
          rel="noopener noreferrer"
          className="proj-preview"
        >
          <img
            src="/laliga-preview.png"
            alt="LaLiga Insights live preview"
          />
          <div className="proj-preview-overlay">
            <span>Visit site ↗</span>
          </div>
        </a>
      </div>

      {/* Character Lamp */}
      <div className="proj-card">
        <div className="proj-top">
          <span className="proj-num">02</span>
          <div className="proj-links-top">
            <a href="https://github.com/shahjahan0011/character-lamp" className="proj-link" target="_blank" rel="noopener noreferrer">
              GitHub ↗
            </a>
          </div>
        </div>
        <div className="proj-title">Character Lamp</div>
        <div className="proj-desc">
          It is a desk-lamp robot built on a simulated five-joint body in PyBullet. It uses
          a laptop's camera, microphone and speaker to notice people, hold spoken
          conversations, remember objects it has seen, and look or point toward them on
          request. The goal was to create an aware character rather than random AI slop.
        </div>
        <div className="proj-stack">
          <span>Python</span><span>Gemini Live API</span><span>PyBullet</span>
          <span>OpenCV</span><span>Pydantic</span>
        </div>
      </div>

      {/* Disease Detection */}
      <div className="proj-card">
        <div className="proj-top">
          <span className="proj-num">03</span>
          <div className="proj-links-top">
            <a href="https://github.com/shahjahan0011/potato-disease" className="proj-link" target="_blank" rel="noopener noreferrer">
              GitHub ↗
            </a>
          </div>
        </div>
        <div className="proj-title">Potato Disease Classification</div>
        <div className="proj-highlight">
          <span className="highlight-pill green">&gt;96% accuracy</span>
          <span className="highlight-pill">Deployed on GCP</span>
        </div>
        <div className="proj-desc">
          Trained a MobileNetV2-based potato disease classifier with transfer learning,
          reaching <strong>&gt;96% validation accuracy</strong> on the project dataset.
          Wrapped the model in a FastAPI inference service and supported both local
          TensorFlow inference and containerized TensorFlow Serving with Docker.
        </div>
        <div className="proj-stack">
          <span>TensorFlow</span><span>MobileNetV2</span><span>FastAPI</span>
          <span>Docker</span><span>GCP</span>
        </div>
      </div>

      {/* LavaLock */}
      <div className="proj-card">
        <div className="proj-top">
          <span className="proj-num">04</span>
          <div className="proj-links-top">
            <a href="https://github.com/shahjahan0011/Lavalock" className="proj-link" target="_blank" rel="noopener noreferrer">
              GitHub ↗
            </a>
          </div>
        </div>
        <div className="proj-title">LavaLock</div>
        <div className="proj-highlight">
          <span className="highlight-pill">Cryptography</span>
          <span className="highlight-pill">Computer Vision</span>
        </div>
        <div className="proj-desc">
          Recreated the idea behind <strong>Cloudflare's Lava Wall</strong> using OpenCV to
          capture visual entropy from live image data and JavaFX for the interface. Fed
          changing pixel data through SHA-256 to explore how physical randomness can be
          used as an entropy source for cryptographic systems.
        </div>
        <div className="proj-stack">
          <span>Java</span><span>OpenCV</span><span>JavaFX</span><span>SHA-256</span>
        </div>
      </div>

      {/* StopPi&Go */}
      <div className="proj-card">
        <div className="proj-top">
          <span className="proj-num">05</span>
          <div className="proj-links-top">
            <a href="https://www.youtube.com/watch?v=f90YzP5t0F4" className="proj-link" target="_blank" rel="noopener noreferrer">
              YouTube ↗
            </a>
          </div>
        </div>
        <div className="proj-title">StopPi&amp;Go</div>
        <div className="proj-highlight">
          <span className="highlight-pill green">98% uptime</span>
          <span className="highlight-pill green">1,000+ cycles logged</span>
        </div>
        <div className="proj-desc">
          Raspberry Pi as central traffic controller interfaced with Arduino for real-time
          LED signal management in C++ on Linux. <strong>Multi-threaded architecture</strong>{' '}
          with sensor-triggered interrupts. State, Singleton, and Facade design patterns for
          clean phase management and scalability. 98% uptime across stress testing with
          1,000+ logged cycles.
        </div>
        <div className="proj-stack">
          <span>C++</span><span>Raspberry Pi</span><span>Arduino</span>
          <span>Linux</span><span>Multithreading</span>
        </div>
      </div>

      {/* AllYouNeedToKnow — full width, split layout like StopPi&Go */}
      <div className="proj-card span2" style={{ alignItems: 'center' }}>
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div className="proj-top">
            <span className="proj-num">06</span>
            <div className="proj-links-top">
              <a href="https://github.com/shahjahan0011/my-claude-skills/tree/main/all-you-need-to-know" className="proj-link" target="_blank" rel="noopener noreferrer">
                GitHub ↗
              </a>
            </div>
          </div>
          <div className="proj-title">AllYouNeedToKnow</div>
          <div className="proj-highlight">
            <span className="highlight-pill">Claude skill</span>
            <span className="highlight-pill">Live research</span>
          </div>
        </div>
        <div style={{ flex: 1.4, display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div className="proj-desc">
            Built a Claude skill that takes an interview email, researches the company and
            interviewer live, and turns the findings into a structured Word briefing. Worked
            through browser permissions and JavaScript-heavy pages to pull useful context from
            company sites, LinkedIn, Glassdoor, and news sources; used it for real interview
            prep including Super.com and SIG.
          </div>
          <div className="proj-stack">
            <span>LLM APIs</span><span>Browser automation</span><span>Document generation</span>
          </div>
        </div>
      </div>

    </div>
  </section>
);

export default Projects;